import React, { useEffect, useState } from "react";
import '../../Assets/styles.css';

const AllNotification = ({ articles, onNotificationClick }) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getTypeColor = (type) => {
        switch (type?.toLowerCase()) {
            case 'appointment':
                return '#4CAF50';
            case 'community':
                return '#2196F3';
            case 'article':
                return '#FF9800';
            default:
                return '#666';
        }
    };

    const getTypeIcon = (type) => {
        switch (type?.toLowerCase()) {
            case 'appointment':
                return '📅';
            case 'community':
                return '👥';
            case 'article':
                return '📄';
            default:
                return '📢';
        }
    };

    if (!articles || articles.length === 0) {
        return (
            <div style={{ 
                padding: '40px', 
                textAlign: 'center', 
                color: '#666',
                fontSize: '16px'
            }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>📭</div>
                <p>No notifications found</p>
            </div>
        );
    }

    return (
        <div style={{ padding: '20px' }}>
            {articles.map((notification) => (
                <div
                    key={notification.id}
                    onClick={() => onNotificationClick && onNotificationClick(notification)}
                    style={{
                        backgroundColor: notification.isRead ? '#fff' : '#f8f9fa',
                        border: `1px solid ${notification.isRead ? '#e0e0e0' : '#4CAF50'}`,
                        borderRadius: '8px',
                        padding: '16px',
                        marginBottom: '12px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        position: 'relative',
                        boxShadow: notification.isRead ? '0 1px 3px rgba(0,0,0,0.1)' : '0 2px 8px rgba(76,175,80,0.2)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = notification.isRead ? '0 1px 3px rgba(0,0,0,0.1)' : '0 2px 8px rgba(76,175,80,0.2)';
                    }}
                >
                    {/* Unread indicator */}
                    {!notification.isRead && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                width: '10px',
                                height: '10px',
                                backgroundColor: '#4CAF50',
                                borderRadius: '50%'
                            }}
                        />
                    )}

                    {/* Type badge with navigation hint */}
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: getTypeColor(notification.type),
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: '600',
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            gap: '4px'
                        }}
                    >
                        <span>{getTypeIcon(notification.type)}</span>
                        {notification.type}
                        <span style={{ fontSize: '10px', opacity: 0.8 }}>→</span>
                    </div>

                    {/* Title */}
                    <h3
                        style={{
                            margin: '0 0 8px 0',
                            fontSize: '16px',
                            fontWeight: notification.isRead ? '500' : '600',
                            color: notification.isRead ? '#333' : '#000'
                        }}
                    >
                        {notification.displayTitle || notification.title}
                    </h3>

                    {/* Message */}
                    <p
                        style={{
                            margin: '0 0 12px 0',
                            fontSize: '14px',
                            color: '#666',
                            lineHeight: '1.4'
                        }}
                    >
                        {notification.message}
                    </p>

                    {/* Date and status */}
                    <div
                        style={{
                            fontSize: '12px',
                            color: '#999',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <span>{formatDate(notification.createdAt)}</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {!notification.isRead && (
                                <span
                                    style={{
                                        backgroundColor: '#4CAF50',
                                        color: 'white',
                                        padding: '2px 6px',
                                        borderRadius: '10px',
                                        fontSize: '10px',
                                        fontWeight: '600'
                                    }}
                                >
                                    NEW
                                </span>
                            )}
                            <span style={{ 
                                fontSize: '10px', 
                                color: '#999',
                                fontStyle: 'italic'
                            }}>
                                Click to view
                            </span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AllNotification;
